import { render, staticRenderFns } from "./ChartCanvas.vue?vue&type=template&id=42383ad8&scoped=true"
import script from "./ChartCanvas.vue?vue&type=script&lang=js"
export * from "./ChartCanvas.vue?vue&type=script&lang=js"
import style0 from "./ChartCanvas.vue?vue&type=style&index=0&id=42383ad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42383ad8",
  null
  
)

export default component.exports